export default {
  subtotal: {
    en: 'Subtotal',
  },
  shipping: {
    en: 'Shipping',
  },
  tax: {
    en: 'Tax',
  },
  discount: {
    en: 'Discount',
  },
  free: {
    en: 'Free',
  },
  ecommerceCredits: {
    en: 'Ecommerce gift credits',
  },
}
